const valuesToFilter = [null, undefined, ""];

export const generateFormData = (formData, values, parentKey = "") => {
  if (!values) return;
  Object.entries(values).forEach(([key, value]) => {
    if (
      (typeof value !== "object" || value instanceof File) &&
      !valuesToFilter.includes(value)
    ) {
      formData.append(
        `${parentKey ? `${parentKey}.` : ""}${key}`,
        typeof value === "string" ? value.trim() : value
      );
    } else if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item !== "object" || item instanceof File) {
          formData.append(
            `${parentKey ? `${parentKey}.` : ""}${key}[${index}]`,
            item
          );
        } else {
          generateFormData(
            formData,
            item,
            `${parentKey ? `${parentKey}.` : ""}${key}[${index}]`
          );
        }
      });
    } else {
      generateFormData(
        formData,
        value,
        `${parentKey ? `${parentKey}.` : ""}${key}`
      );
    }
  });
};
